module.exports = __webpack_public_path__ + "img/RORBPJS40058.8f8cf1f5.png";